export default "__VITE_ASSET__1CTzNEIU__"